var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("my-asidebar", { attrs: { "active-tab": "reports" } }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "dashboard-area p-3" },
        [
          _c("top-bar"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-12" }, [
              _c(
                "div",
                { staticClass: "form-box" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "v-app",
                    [
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.forecastData,
                          "items-per-page": 100,
                          search: _vm.search,
                          "custom-filter": _vm.filter,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.sailDate",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c("tr", [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm._f("ddMMyyyy")(item.sailDate)
                                      ) +
                                      "\n                    "
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-title-wrap" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-between" },
        [_c("h3", { staticClass: "title" }, [_vm._v("Sail Booking Report")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }